<mat-form-field [formGroup]="form" class="example-full-width" fxFlex="100%">

  <mat-label>{{ filter.display }}</mat-label>
  <input type="text" matInput [formControlName]="filter.key" [formControl]="myControl" [(ngModel)]="selected"  [matAutocomplete]="auto" (blur)="verifyOnBlur()">

  <button type="button" *ngIf="selected" matSuffix mat-icon-button (click)="onDelete()">
    <mat-icon>close</mat-icon>
  </button>

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)='onSelect($event.option.value)'>
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option" (mousedown)="$event.preventDefault()">
      {{option}}
    </mat-option>
  </mat-autocomplete>

</mat-form-field>